// extracted by mini-css-extract-plugin
export default {"wrapper":"about_wrapper__paoPU"};